export default __webpack_public_path__ + "Avenir-HeavyOblique.ttf";